import React, { Component } from 'react';
import { Form, Modal, Input } from 'antd';
import moment from 'moment';

const FormItem = Form.Item;
class ModalDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {}

  componentDidMount() {}

  handleOk = () => {
    const { data } = this.props;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.onOk({
          ...data,
          ...values,
        });
      }
    });
  };

  render() {
    const { data } = this.props;
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };
    return (
      <Modal title="编辑流水" onCancel={this.props.onCancel} onOk={this.handleOk} visible>
        <Form>
          <FormItem label="日期" {...formItemLayout}>
            {moment.unix(data.date / 1000).format('YYYY-MM-DD')}
          </FormItem>
          <FormItem label="客户名称" {...formItemLayout}>
            {data.customName}
          </FormItem>
          <FormItem label="金额" {...formItemLayout}>
            {data.money}
          </FormItem>
          <FormItem label="类型" {...formItemLayout}>
            {data.target === 0 ? '支出' : '收入'}
          </FormItem>
          <FormItem label="摘要" {...formItemLayout}>
            {getFieldDecorator('remark', {
              initialValue: data.remark,
            })(
              <Input.TextArea
                placeholder="摘要"
                type="textarea"
                autosize={{ minRows: 3, maxRows: 9 }}
                maxLength={1000}
              />,
            )}
            <span style={{ fontSize: '12px', color: '#999' }}>*最多可输入1000字</span>
          </FormItem>
        </Form>
      </Modal>
    );
  }
}
export default Form.create({ wrappedComponentRef: true })(ModalDetail);



// WEBPACK FOOTER //
// ./src/components/incubator/income/ModalDetail.js